(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aa-complete-collection-marquee"] && !Shopify.designMode) return;
  try {
    const aaCompleteCollectionSelector = '.aa-complete-collection-marquee';
  const aaCompleteCollectionSvgNamespace = 'http://www.w3.org/2000/svg';
  const aaCompleteCollectionFullTurn = Math.PI * 2;

  const getCompleteCollectionMarquees = (root = document) => {
    const marquees = [];

    if (root.matches?.(aaCompleteCollectionSelector)) {
      marquees.push(root);
    }

    marquees.push(...(root.querySelectorAll?.(aaCompleteCollectionSelector) || []));
    return marquees;
  };

  const initializeCompleteCollectionMarquee = (marquee) => {
    if (marquee.dataset.motionInitialized === 'true') return;

    marquee.dataset.motionInitialized = 'true';
    const track = marquee.querySelector('.aa-complete-collection-marquee__track');
    const sourceSet = track?.querySelector('.aa-complete-collection-marquee__set');
    const guideSvg = marquee.querySelector('.aa-complete-collection-marquee__guides');
    const guidePaths = {
      base: guideSvg?.querySelector('[data-guide="base"]'),
      broad: guideSvg?.querySelector('[data-guide="broad"]'),
      squiggle: guideSvg?.querySelector('[data-guide="squiggle"]'),
      final: guideSvg?.querySelector('[data-guide="final"]'),
    };
    const guideCenters = guideSvg?.querySelector('[data-guide-centers]');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const readNumber = (name, fallback) => {
      const value = Number(marquee.dataset[name]);
      return Number.isFinite(value) ? value : fallback;
    };
    const normalizeLegacyFrequency = (value) => Math.abs(value) > 20 ? value / 200 : value;
    const normalizeLegacyCurvature = (value) => Math.abs(value) > 50 ? value / 100 : value;
    const normalizeLegacyCurvatureBreath = (value) => Math.abs(value) > 4 ? value / 100 : value;
    const settings = {
      motionEnabled: marquee.dataset.motionEnabled !== 'false',
      stackOrder: marquee.dataset.stackOrder || 'right_over_left',
      reducedMotion: marquee.dataset.reducedMotion || 'freeze',
      pathCenter: readNumber('pathCenter', 0.38),
      pathVertical: readNumber('pathVertical', 0.84),
      pathOffset: readNumber('pathOffset', 0.92),
      pathCurvature: normalizeLegacyCurvature(readNumber('pathCurvature', 4)),
      primaryAmplitude: readNumber('primaryAmplitude', 0.06),
      primaryFrequency: normalizeLegacyFrequency(readNumber('primaryFrequency', 0.7)),
      primaryPhase: readNumber('primaryPhase', -30) * Math.PI / 180,
      secondaryAmplitude: readNumber('secondaryAmplitude', 0.024),
      secondaryFrequency: normalizeLegacyFrequency(readNumber('secondaryFrequency', 2.2)),
      secondaryPhase: readNumber('secondaryPhase', 50) * Math.PI / 180,
      detailAmplitude: readNumber('detailAmplitude', 0.012),
      detailFrequency: readNumber('detailFrequency', 4.5),
      detailPhase: readNumber('detailPhase', -80) * Math.PI / 180,
      breathDuration: Math.max(1, readNumber('breathDuration', 96)),
      verticalBreath: readNumber('verticalBreath', 0.01),
      curvatureBreath: normalizeLegacyCurvatureBreath(readNumber('curvatureBreath', 0.1)),
      contourDrift: readNumber('contourDrift', 0) * Math.PI / 180,
    };
    let animationFrame;
    let resizeFrame;
    let latestMotionTime = 0;
    let latestGuideTime = -Infinity;
    let motionStartTime;
    let thumbnailSize = 0;
    let thumbnailOffsets = [];
    let marqueeWidth = 0;
    let marqueeHeight = 0;
    let trackCenterY = 0;
    let waveDepthPx = 0;
    let forceGuideRender = true;
    let cloneSequence = Number(marquee.dataset.loopCloneSequence) || 0;
    let thumbnails = [];
    let centerMarkers = [];

    const cloneSourceSet = () => {
      const clone = sourceSet.cloneNode(true);
      const idMap = new Map();
      cloneSequence += 1;
      marquee.dataset.loopCloneSequence = String(cloneSequence);
      clone.dataset.marqueeClone = 'true';

      clone.querySelectorAll('[id]').forEach((element) => {
        const originalId = element.id;
        const cloneId = `${originalId}-loop-${cloneSequence}`;
        idMap.set(originalId, cloneId);
        element.id = cloneId;
      });

      clone.querySelectorAll('[fill], [stroke]').forEach((element) => {
        ['fill', 'stroke'].forEach((attribute) => {
          const value = element.getAttribute(attribute);
          if (!value) return;

          const updatedValue = value.replace(/url\(#([^)]+)\)/g, (match, id) => {
            return idMap.has(id) ? `url(#${idMap.get(id)})` : match;
          });
          element.setAttribute(attribute, updatedValue);
        });
      });

      return clone;
    };

    const syncTrackCoverage = () => {
      if (!track || !sourceSet || !marquee.clientWidth) return;

      const sourceThumbnail = sourceSet.querySelector('.aa-complete-collection-marquee__thumbnail');
      const sourceThumbnailSize = sourceThumbnail?.offsetWidth || 0;
      const cycleWidth = sourceSet.getBoundingClientRect().width;
      if (!cycleWidth || !sourceThumbnailSize) return;

      const requiredSetCount = Math.max(
        2,
        Math.ceil((marquee.clientWidth + cycleWidth + sourceThumbnailSize) / cycleWidth)
      );

      while (track.children.length < requiredSetCount) {
        track.appendChild(cloneSourceSet());
      }

      while (track.children.length > requiredSetCount) {
        const lastSet = track.lastElementChild;
        if (!lastSet?.dataset.marqueeClone) break;
        lastSet.remove();
      }

      marquee.style.setProperty('--aa-complete-collection-cycle-shift', `${cycleWidth}px`);
      marquee.dataset.loopSetCount = String(track.children.length);
      marquee.dataset.loopCycleWidth = String(cycleWidth);
    };

    const syncThumbnails = () => {
      thumbnails = Array.from(
        marquee.querySelectorAll('.aa-complete-collection-marquee__thumbnail')
      );

      thumbnails.forEach((thumbnail, index) => {
        const stackIndex = settings.stackOrder === 'left_over_right'
          ? thumbnails.length - index
          : index + 1;
        thumbnail.style.zIndex = String(stackIndex);
      });

      if (!guideCenters || centerMarkers.length === thumbnails.length) return;

      guideCenters.replaceChildren();
      centerMarkers = thumbnails.map(() => {
        const marker = document.createElementNS(aaCompleteCollectionSvgNamespace, 'circle');
        marker.setAttribute('class', 'aa-complete-collection-marquee__guide-center');
        marker.setAttribute('r', '4');
        guideCenters.appendChild(marker);
        return marker;
      });
    };

    const getPathState = (motionTime) => {
      const seconds = motionTime / 1000;
      const cycle = seconds * aaCompleteCollectionFullTurn / settings.breathDuration;
      const simpleFlow = Math.sin(cycle);
      const counterFlow = Math.sin(cycle * 0.61 + 1.12);
      const detailFlow = Math.sin(cycle * 1.37 - 0.74);
      const complexity = 0.35;
      const morphAmount = 0.15;
      const flow = simpleFlow * (1 - complexity) +
        (simpleFlow * 0.52 + counterFlow * 0.31 + detailFlow * 0.17) * complexity;
      const arcFlow = simpleFlow * 0.68 + counterFlow * 0.32;

      return {
        vertical: settings.pathVertical + flow * settings.verticalBreath,
        curvature: settings.pathCurvature + arcFlow * settings.curvatureBreath,
        primaryAmplitude: settings.primaryAmplitude *
          (1 + morphAmount * 0.18 * counterFlow),
        secondaryAmplitude: settings.secondaryAmplitude *
          (1 + morphAmount * 0.34 * detailFlow),
        detailAmplitude: settings.detailAmplitude *
          (1 + morphAmount * 0.5 * simpleFlow),
        primaryPhase: settings.primaryPhase + flow * settings.contourDrift,
        secondaryPhase: settings.secondaryPhase +
          (counterFlow * 0.72 + simpleFlow * 0.28) * settings.contourDrift * 1.7,
        detailPhase: settings.detailPhase +
          (detailFlow * 0.64 + counterFlow * 0.36) * settings.contourDrift * 2.3,
      };
    };

    const samplePathComponents = (position, state) => {
      const distance = position - settings.pathCenter;
      const base = state.vertical - state.curvature * distance * distance;
      const broad = base + state.primaryAmplitude * Math.sin(
        aaCompleteCollectionFullTurn * settings.primaryFrequency * distance + state.primaryPhase
      );
      const squiggle = broad + state.secondaryAmplitude * Math.sin(
        aaCompleteCollectionFullTurn * settings.secondaryFrequency * distance + state.secondaryPhase
      );
      const final = squiggle + state.detailAmplitude * Math.sin(
        aaCompleteCollectionFullTurn * settings.detailFrequency * distance + state.detailPhase
      );

      return { base, broad, squiggle, final };
    };

    const measure = () => {
      syncTrackCoverage();
      syncThumbnails();
      thumbnailSize = thumbnails[0]?.offsetWidth || 0;
      thumbnailOffsets = thumbnails.map((thumbnail) => thumbnail.offsetLeft);
      const marqueeRect = marquee.getBoundingClientRect();
      const trackRect = track?.getBoundingClientRect();
      marqueeWidth = marquee.clientWidth;
      marqueeHeight = marquee.clientHeight;
      trackCenterY = trackRect ? trackRect.top - marqueeRect.top + thumbnailSize / 2 : 0;

      if (guideSvg) {
        const depthProbe = document.createElement('span');
        depthProbe.style.cssText = 'position:absolute;visibility:hidden;width:var(--aa-complete-collection-wave-depth);height:0;pointer-events:none;';
        marquee.appendChild(depthProbe);
        waveDepthPx = depthProbe.getBoundingClientRect().width;
        depthProbe.remove();
        guideSvg.setAttribute('viewBox', `0 0 ${Math.max(1, marqueeWidth)} ${Math.max(1, marqueeHeight)}`);
      }
    };

    const updateGuideCenters = (positions, state, flatPath) => {
      if (!centerMarkers.length) return;

      positions.forEach((position, index) => {
        const marker = centerMarkers[index];
        const isVisible = position >= -0.03 && position <= 1.03;
        const pathValue = flatPath ? settings.pathOffset : samplePathComponents(position, state).final;
        marker.style.display = isVisible ? '' : 'none';
        marker.setAttribute('cx', String(position * marqueeWidth));
        marker.setAttribute('cy', String(trackCenterY + waveDepthPx * (pathValue - settings.pathOffset)));
      });
    };

    const renderGuidePaths = (state, flatPath, motionTime) => {
      if (!guideSvg || !marqueeWidth || !marqueeHeight) return;
      if (!forceGuideRender && motionTime - latestGuideTime < 100) return;

      const highestFrequency = Math.max(
        settings.primaryFrequency,
        settings.secondaryFrequency,
        settings.detailFrequency
      );
      const sampleCount = Math.min(320, Math.max(64, Math.ceil(highestFrequency * 16)));
      const pathData = { base: [], broad: [], squiggle: [], final: [] };

      for (let index = 0; index <= sampleCount; index += 1) {
        const position = index / sampleCount;
        const x = position * marqueeWidth;
        const components = flatPath
          ? { base: settings.pathOffset, broad: settings.pathOffset, squiggle: settings.pathOffset, final: settings.pathOffset }
          : samplePathComponents(position, state);

        Object.keys(pathData).forEach((name) => {
          const y = trackCenterY + waveDepthPx * (components[name] - settings.pathOffset);
          pathData[name].push(`${index === 0 ? 'M' : 'L'}${x.toFixed(2)} ${y.toFixed(2)}`);
        });
      }

      Object.entries(guidePaths).forEach(([name, path]) => {
        path?.setAttribute('d', pathData[name].join(' '));
      });
      latestGuideTime = motionTime;
      forceGuideRender = false;
    };

    const renderPath = (motionTime = latestMotionTime) => {
      if (!track || !thumbnails.length || !marquee.clientWidth) return;

      latestMotionTime = typeof motionTime === 'number' ? motionTime : latestMotionTime;
      const marqueeRect = marquee.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      const state = getPathState(latestMotionTime);
      const flatPath = motionQuery.matches && settings.reducedMotion === 'flat';
      const positions = thumbnailOffsets.map((thumbnailOffset) => {
        const center = trackRect.left + thumbnailOffset + thumbnailSize / 2;
        return (center - marqueeRect.left) / marqueeRect.width;
      });

      positions.forEach((position, index) => {
        const pathValue = flatPath
          ? settings.pathOffset
          : samplePathComponents(position, state).final;
        const displayValue = pathValue - settings.pathOffset;
        const thumbnail = thumbnails[index];

        thumbnail.style.transform = `translate3d(0, calc(var(--aa-complete-collection-wave-depth) * ${displayValue}), 0)`;
      });
      updateGuideCenters(positions, state, flatPath);
      renderGuidePaths(state, flatPath, latestMotionTime);
    };

    const animate = (frameTime = 0) => {
      if (!marquee.isConnected) {
        marquee.aaCompleteCollectionCleanup?.();
        return;
      }

      if (motionStartTime === undefined && frameTime > 0) {
        motionStartTime = frameTime;
      }

      const motionTime = motionStartTime === undefined ? 0 : Math.max(0, frameTime - motionStartTime);
      renderPath(motionTime);

      if (settings.motionEnabled && !motionQuery.matches) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    const handleMotionChange = () => {
      cancelAnimationFrame(animationFrame);
      motionStartTime = undefined;
      forceGuideRender = true;
      animate();
    };

    const handleResize = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        forceGuideRender = true;
        measure();
        renderPath();
      });
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(marquee);
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', handleMotionChange);
    } else {
      motionQuery.addListener(handleMotionChange);
    }
    marquee.aaCompleteCollectionCleanup = () => {
      cancelAnimationFrame(animationFrame);
      cancelAnimationFrame(resizeFrame);
      resizeObserver.disconnect();
      if (motionQuery.removeEventListener) {
        motionQuery.removeEventListener('change', handleMotionChange);
      } else {
        motionQuery.removeListener(handleMotionChange);
      }
      marquee.dataset.motionInitialized = 'false';
      delete marquee.aaCompleteCollectionCleanup;
    };
    measure();
    animate();
  };

  const initializeCompleteCollectionMarquees = (root = document) => {
    getCompleteCollectionMarquees(root).forEach(initializeCompleteCollectionMarquee);
  };

  initializeCompleteCollectionMarquees();

  if (!window.aaCompleteCollectionEditorEventsBound) {
    document.addEventListener('shopify:section:load', (event) => {
      getCompleteCollectionMarquees(event.target).forEach((marquee) => {
        marquee.aaCompleteCollectionCleanup?.();
        initializeCompleteCollectionMarquee(marquee);
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      initializeCompleteCollectionMarquees(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      getCompleteCollectionMarquees(event.target).forEach((marquee) => {
        marquee.aaCompleteCollectionCleanup?.();
      });
    });
    window.aaCompleteCollectionEditorEventsBound = true;
  }
  } catch(e) { console.error(e); }
})();

})();
